var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        attrs: { "data-vv-scope": "step-2-part-1", autocomplete: "off" },
        on: {
          submit: function($event) {
            $event.preventDefault()
          }
        }
      },
      [
        _c("div", { staticClass: "row mb-5" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c("list-user-groups", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: _vm.userGroupsState.list.length > 1 },
                    expression: "{ required: userGroupsState.list.length > 1 }"
                  }
                ],
                ref: "creatorGroup",
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  "only-groups": "",
                  label: "Grupo al que irá asociado el expediente (*)",
                  name: "creatorGroup",
                  danger: _vm.errors.has("step-2-part-1.creatorGroup"),
                  "danger-text": _vm.errors.first("step-2-part-1.creatorGroup")
                },
                model: {
                  value: _vm.step.creatorGroup,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "creatorGroup", $$v)
                  },
                  expression: "step.creatorGroup"
                }
              })
            ],
            1
          )
        ]),
        _vm._m(1),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c("list-institution-types", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                ref: "institutionType",
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Tipo Institución (*)",
                  name: "institutionType",
                  danger: _vm.errors.has("step-2-part-1.institutionType"),
                  "danger-text": _vm.errors.first(
                    "step-2-part-1.institutionType"
                  )
                },
                model: {
                  value: _vm.step.institutionType,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "institutionType", $$v)
                  },
                  expression: "step.institutionType"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c("list-institutions", {
                ref: "institution",
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Institución",
                  name: "institution",
                  "parent-value": _vm.step.institutionType
                },
                model: {
                  value: _vm.step.institution,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "institution", $$v)
                  },
                  expression: "step.institution"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("vs-input", {
                staticClass: "w-100",
                attrs: {
                  label: "Nombre Persona",
                  maxlength: "50",
                  name: "personName",
                  autocomplete: "off"
                },
                model: {
                  value: _vm.step.personName,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "personName", $$v)
                  },
                  expression: "step.personName"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c("vs-input", {
                staticClass: "w-100",
                attrs: {
                  label: "Cargo Persona",
                  maxlength: "50",
                  name: "personPosition",
                  autocomplete: "off"
                },
                model: {
                  value: _vm.step.personPosition,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "personPosition", $$v)
                  },
                  expression: "step.personPosition"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "email",
                    expression: "'email'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  label: "Correo Persona",
                  maxlength: "70",
                  name: "personEmail",
                  danger: _vm.errors.has("step-2-part-1.personEmail"),
                  "danger-text": _vm.errors.first("step-2-part-1.personEmail"),
                  autocomplete: "off"
                },
                model: {
                  value: _vm.step.personEmail,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "personEmail", $$v)
                  },
                  expression: "step.personEmail"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mb-3" }, [
          _c("div", { staticClass: "col-12" }, [_c("vs-divider")], 1)
        ])
      ]
    ),
    _c(
      "form",
      {
        attrs: { "data-vv-scope": "step-2-part-2", autocomplete: "off" },
        on: {
          submit: function($event) {
            $event.preventDefault()
          }
        }
      },
      [
        _vm._m(2),
        !_vm.maxSubjectActives
          ? _c("SelectSubjectPublic", {
              attrs: {
                "need-providence": "",
                "filter-me": "",
                "date-limit": _vm.step.expirationDate
              },
              on: { "add-subject": _vm.addSubject }
            })
          : _vm._e(),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("TableSubjects", {
                attrs: { subjects: _vm.step.subjects },
                model: {
                  value: _vm.step.subjectsSelected,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "subjectsSelected", $$v)
                  },
                  expression: "step.subjectsSelected"
                }
              })
            ],
            1
          )
        ])
      ],
      1
    ),
    _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [_c("vs-divider")], 1)
    ]),
    _c(
      "form",
      {
        attrs: { "data-vv-scope": "step-2-part-3" },
        on: {
          submit: function($event) {
            $event.preventDefault()
          }
        }
      },
      [
        _vm._m(3),
        _c("SelectCopyPublic", {
          attrs: { "providence-date": _vm.providenceDate },
          on: { "add-copy": _vm.addCopy }
        }),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("TableCopies", {
                attrs: { copies: _vm.step.copies },
                model: {
                  value: _vm.step.copiesSelected,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "copiesSelected", $$v)
                  },
                  expression: "step.copiesSelected"
                }
              })
            ],
            1
          )
        ])
      ],
      1
    ),
    _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [_c("vs-divider")], 1)
    ]),
    _c(
      "form",
      {
        attrs: { "data-vv-scope": "step-2-part-4", autocomplete: "off" },
        on: {
          submit: function($event) {
            $event.preventDefault()
          }
        }
      },
      [
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c(
                "vs-select",
                {
                  staticClass: "w-100",
                  attrs: {
                    "data-cy": "annexed",
                    autocomplete: "",
                    label: "Anexo",
                    name: "esFisico"
                  },
                  model: {
                    value: _vm.step.withAttachment,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "withAttachment", $$v)
                    },
                    expression: "step.withAttachment"
                  }
                },
                [
                  _c("vs-select-item", { attrs: { value: "0", text: "No" } }),
                  _c("vs-select-item", { attrs: { value: "1", text: "Si" } })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c(
                "vs-select",
                {
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "",
                    label: "Requiere Respuesta",
                    name: "requiereResponse"
                  },
                  model: {
                    value: _vm.step.requiereResponse,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "requiereResponse", $$v)
                    },
                    expression: "step.requiereResponse"
                  }
                },
                [
                  _c("vs-select-item", { attrs: { value: "0", text: "No" } }),
                  _c("vs-select-item", { attrs: { value: "1", text: "Si" } })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm.validWithAttachment
          ? _c("div", { staticClass: "row mb-3" }, [
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c("vs-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { required: _vm.validWithAttachment },
                        expression: "{ required: validWithAttachment }"
                      }
                    ],
                    staticClass: "w-100",
                    attrs: {
                      label: "Detalle (*)",
                      maxlength: "250",
                      name: "documentDetail",
                      danger: _vm.errors.has("step-2-part-4.documentDetail"),
                      "danger-text": _vm.errors.first(
                        "step-2-part-4.documentDetail"
                      ),
                      autocomplete: "off"
                    },
                    model: {
                      value: _vm.step.documentDetail,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "documentDetail", $$v)
                      },
                      expression: "step.documentDetail"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  label: "Asunto (*)",
                  maxlength: "250",
                  "data-cy": "affair",
                  name: "asunto",
                  autocomplete: "off",
                  danger: _vm.errors.has("step-2-part-4.asunto"),
                  "danger-text": _vm.errors.first("step-2-part-4.asunto")
                },
                model: {
                  value: _vm.step.asunto,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "asunto", $$v)
                  },
                  expression: "step.asunto"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("label", { attrs: { for: "observation" } }, [
                _vm._v("Observación")
              ]),
              _c("vs-textarea", {
                attrs: {
                  type: "text",
                  id: "observation",
                  maxlength: "5000",
                  label: "Observación (5000 caracteres)",
                  "data-cy": "observation",
                  name: "observacion",
                  "data-vv-as": "observación",
                  width: "100%",
                  height: "100px"
                },
                model: {
                  value: _vm.step.observation,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "observation", $$v)
                  },
                  expression: "step.observation"
                }
              }),
              _vm.errors.first("step-2-part-4.observacion")
                ? _c(
                    "div",
                    {
                      staticClass:
                        "con-text-validation span-text-validation-danger\n           vs-input--text-validation-span v-enter-to",
                      staticStyle: { height: "32px" }
                    },
                    [
                      _c("span", { staticClass: "span-text-validation" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.errors.first("step-2-part-4.observacion")
                            ) +
                            " "
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _c("div", { staticClass: "text-right" }, [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Contador de caracteres",
                        expression: "'Contador de caracteres'"
                      }
                    ]
                  },
                  [_vm._v(_vm._s(_vm.step.observation.length) + "/5000")]
                )
              ])
            ],
            1
          )
        ]),
        _vm.error.message !== ""
          ? _c(
              "div",
              {
                staticClass:
                  "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to text-right",
                staticStyle: { height: "32px" }
              },
              [
                _c("span", { staticClass: "span-text-validation" }, [
                  _vm._v(" " + _vm._s(_vm.error.message) + " ")
                ])
              ]
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v("Datos de la persona que ingresa el documento")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", [_vm._v("Origen / Datos Remitente")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", [_vm._v("Destinatario (*)")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [_c("h4", [_vm._v("Con copia a")])])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }